'use strict';

app.controller('ObjectCtrl', [
    '$scope',
    '$rootScope',
    '$timeout',
    '$http',
    '$localStorage',
    '$window',
    'uiGmapIsReady',
    '$cookies',
    '$stateParams',
    'toaster',
    '$translate',
    '$ngConfirm',
    '$state',
    '$q',
    'GoogleMapService',
    'ObjectManager',
    'VehicleCollection',
    'UIObjectWindow',
    'AccessManagerService',
    'DistributionService',
    function(
        $scope,
        $rootScope,
        $timeout,
        $http,
        $localStorage,
        $window,
        uiGmapIsReady,
        $cookies,
        $stateParams,
        toaster,
        $translate,
        $ngConfirm,
        $state,
        $q,
        GoogleMapService,
        ObjectManager,
        VehicleCollection,
        UIObjectWindow,
        AccessManagerService,
        DistributionService
    ) {
        var $ctrl = this;
        $localStorage.isSignedIn = true;

        /**
         * Cookies expiration date
         */
        var cookieExpirationDate = new Date();
        cookieExpirationDate.setDate(cookieExpirationDate.getDate() + 365);

        var INFO_WINDOW_NO_ACTION = 0;
        var INFO_WINDOW_OPEN = 1;
        var INFO_WINDOW_CLOSE = 2;

        var ZOOM_OBJECT = 14;

        /**
         * ViewMode - used for selected view
         * 1. object
         * 2. route
         */
        $scope.viewMode = 'object';

        $scope.trafficLayer = null;

        /*
         * Controller init function
         */
        $scope.init = function() {
            GoogleMapService.reset();

            $scope.initCookies();
            $scope.getUserSettings();
            $scope.load();
            getApplicationSettingForUser();
        };

        $scope.isShowedAddressAsBeam = false;
        var getApplicationSettingForUser = function() {
            $http.get('/api/applicationSetting/getIsShowedAddressAsBeam').then(
                function(response) {
                    $scope.isShowedAddressAsBeam = response.data.data.isShowedAddressAsBeam;
                },
                function() {
                    $scope.isShowedAddressAsBeam = false;
                }
            );
        };

        /**
         * Function get all logged in user settings
         */
        $scope.getUserSettings = function() {
            var settings = $rootScope.app.user.userSettings;
            var refreshTime = ((settings || {}).objects || {}).refresh;

            if (typeof refreshTime !== 'undefined') {
                refreshTime = parseInt(refreshTime);
                if (refreshTime >= 10) {
                    $scope.automaticRefreshTimeInMiliseconds = refreshTime * 1000;
                }
            }
        };

        $scope.initCookies = function() {
            $scope.isAutomaticRefresh = $cookies.get('isAutomaticRefresh') > 0;

            var sortColumn = $cookies.get('sortColumn');
            var sortType = $cookies.get('sortType');

            sortColumn && ($rootScope.app.sort.column = sortColumn);
            sortType && ($rootScope.app.sort.type = sortType);

            /*
             * Columns cookies
             */
            columns.initCookie();
        };

        /**
         * UIObjectWindow
         */
        $ctrl.uiObjectWindow = null;

        /**
         * The 'map is ready' logic
         */
        $scope.gMapPromise = function() {
            uiReady()
                .then(function() {
                    $scope.$on('reloadObjects', function(event, args) {
                        $scope.reloadScopeObjects(args.desktop);
                    });

                    GoogleMapService.set($scope.map);
                    uiGlRouteApi.init(GoogleMapService.get(), $rootScope.app.user.userSettings);

                    $scope.postDataLoadMapLogic(true);
                })
                .then(function() {
                    onGroupObjectsOn($ctrl.gtApi.getOption('groupObjectsOn'));
                    $ctrl.gtApi.onGoogleMapLoad(GoogleMapService.get());
                })
                .then(function() {
                    if (!$ctrl.uiObjectWindow) {
                        var center = $scope.map.center;

                        $ctrl.uiObjectWindow = new UIObjectWindow();
                        $ctrl.uiObjectWindow
                            .compile($scope)
                            .position(center.latitude, center.longitude)
                            .open(GoogleMapService.get());
                    }
                });
        };

        /**
         * Cancel data synchronization on destroy
         */
        $scope.$on('$destroy', function() {
            $timeout.cancel($scope.loadTimeout);
        });

        $scope.applyIconTransformation = function() {
            var sheet = document.getElementById('stylesheet-transformations');
            var css = '';

            for (var i = 0; i < $scope.markers.length; i++) {
                var transform = $scope.markers[i].transform;
                css +=
                    'img[src="' + transform.image + '"] { transform: rotate(' + String(transform.rotation) + 'deg) } ';
            }
            sheet.innerHTML = css;
        };

        /**
         * Map settings
         */
        $scope.map = GoogleMapService.defaults(['cluster']);
        $scope.map.events = {
            click: function() {
                $scope.$apply();
            },
            idle: function(maps) {
                if (!GoogleMapService.ready()) {
                    return;
                }

                if (GoogleMapService.getZoom() !== maps.getZoom()) {
                    GoogleMapService.setZoom(maps.getZoom());
                    setVehicleClusters();
                    $scope.generateNumberWindows();
                }
            },
        };

        /**
         * Get map center
         * @returns {object}
         */
        $scope.getMapCenter = function() {
            return $scope.map.center;
        };

        $scope.expandedObject = false;
        $scope.expandObject = function(vehicle) {
            $scope.expandedObject = $scope.expandedObject === vehicle ? false : vehicle;

            updateVehiclesShowAddress();

            vehicle.getAddress();
            getExtendedData();

            /*
             * Update visible columns
             */
            $ctrl.setColumnVisibility();
        };

        $scope.showAddress = function(object) {
            object.address.show = !object.address.show;
            object.getAddress();
        };

        /* =====================================================================
         * Section: Objects
         * =================================================================== */

        /**
         * Object refresh interval
         */
        $scope.loadTimeout = null;

        /**
         * All vehicle objects assigned to the user
         */
        $scope.objects = [];

        var vehicleCollection = new VehicleCollection();
        $scope.objects = vehicleCollection.collection;

        $scope.vehicles = vehicleCollection;

        /**
         * Manual / Automatic refreshing
         */
        $scope.isAutomaticRefresh = false;
        $scope.automaticRefreshTimeInMiliseconds = 60000;

        $scope.showToolbar = false;

        /*
         * Function reload objects on map, additionaly for non-mobile
         * views hides info window and unselect selected object
         *
         * @param {bool} desktop
         */
        $scope.reloadScopeObjects = function(desktop) {
            if ($scope.viewMode === 'route') {
                $scope.changeViewMode();
            }

            desktop && $scope.toolbarUnselect(true);
            $scope.isAutomaticRefresh ? $scope.toggleAutomaticRefresh(true) : $scope.toggleAutomaticRefresh(false);
        };

        /**
         * Set refresh type to manual / automatic
         */
        $scope.toggleAutomaticRefresh = function(value) {
            $scope.isAutomaticRefresh = value;
            $cookies.put('isAutomaticRefresh', value ? 1 : -1, {
                expires: cookieExpirationDate,
            });

            $scope.load();
        };

        $scope.searchbox = {
            text: '',
            filtered: [],
        };
        $scope.objectsSearchTurned = false;

        $scope.toggleObjectsSearch = function() {
            $scope.objectsSearchTurned = !$scope.objectsSearchTurned;
        };
        $scope.isObjectsSearchTurned = function() {
            return $scope.objectsSearchTurned;
        };
        $scope.searchObjects = function() {
            var reSearchBox = new RegExp($scope.searchbox.text, 'i');
            var reSpace = new RegExp(' ', 'g');

            var collection = vehicleCollection.list();

            $scope.searchbox.filtered = [];

            for (var key in collection) {
                var o = collection[key];
                var tests = [
                    o.get('number'),
                    o.get('comment'),
                    o.get('number').replace(reSpace, ''),
                    o.get('comment').replace(reSpace, ''),
                    o.get('module').gsmNumber,
                    o.get('module').serialNumber,
                ];
                var filtered = tests.filter(function(v) {
                    return reSearchBox.test(v);
                });
                filtered.length && $scope.searchbox.filtered.push(o.id);
            }
        };
        $scope.isFilteredObject = function(o) {
            return $scope.searchbox.filtered.indexOf(o.id) >= 0;
        };

        $scope.generateTrafficOnMap = function() {
            if (!$scope.trafficLayer) {
                $scope.trafficLayer = new google.maps.TrafficLayer();
            }

            if ($ctrl.gtApi.access.traffic && $ctrl.gtApi.getOption('trafficOnMap')) {
                $scope.trafficLayer.setMap(GoogleMapService.get());
            } else {
                $scope.trafficLayer.setMap(null);
            }
        };

        /**
         * Toggle gmap toolbar
         */
        $scope.toggleToolbar = function() {
            $scope.showToolbar = !$scope.showToolbar;
        };

        /**
         * Get time to refresh objects in seconds depend on logged in user
         *
         * @returns {Number}
         */
        $scope.getAutomaticRefreshTime = function() {
            var seconds = $scope.automaticRefreshTimeInMiliseconds;

            if ($rootScope.app.user.loginId === 792) {
                seconds = 5000;
            }

            return seconds;
        };

        /**
         * Get all vehicle objects
         */
        $scope.load = function() {
            if (
                ($ctrl.gtApi.ready && $ctrl.gtApi.getIsManualRefreshTurned() && !$ctrl.gtApi.getIsAutomaticRefresh()) ||
                !$scope.isObjectViewMode()
            ) {
                return false;
            }

            if ($ctrl.gtApi.ready) {
                $ctrl.gtApi.setIsManualRefreshTurned(true);
            }

            var group = $rootScope.app.group;
            var type = 'list';
            var params = {};

            if (group.id > 0) {
                type = group.type;
                params.id = group.id;
            }

            ObjectManager.load(type, params).then(function(objects) {
                var objectFilteringResults = $scope.getObjectFilteringResults();
                if (objectFilteringResults) {
                    objects = objects.filter(function(o) {
                        return objectFilteringResults.indexOf(o.objectId) >= 0;
                    });
                }

                var loaded = vehicleCollection.loaded;
                if (!loaded) {
                    vehicleCollection.create(objects);

                    $ctrl.gtApi.objects = vehicleCollection.list();

                    /**
                     * initial search
                     */
                    $scope.searchObjects();

                    if ($stateParams.all) {
                        $scope.changeMobileModeToMap();
                    }

                    /**
                     * update columns depends on objects data
                     */
                    columns.setDynamics(vehicleCollection.list());
                } else {
                    vehicleCollection.update(objects);
                }

                $scope.postDataLoadMapLogic(!loaded);

                if ($ctrl.gtApi.ready) {
                    $ctrl.gtApi.setIsManualRefreshTurned(false);
                }

                updateVehiclesShowAddress();
                getExtendedData();

                if (vehicleCollection.isSelected()) {
                    $scope.goToObject(vehicleCollection.getSelected(), INFO_WINDOW_NO_ACTION);
                }

                $owApi.call.change();
            });

            if ($scope.isAutomaticRefresh || ($ctrl.gtApi.ready && $ctrl.gtApi.getIsAutomaticRefresh())) {
                if ($ctrl.gtApi.ready) {
                    $scope.isAutomaticRefresh = $ctrl.gtApi.getIsAutomaticRefresh();
                }
                $timeout.cancel($scope.loadTimeout);
                $scope.loadTimeout = $timeout($scope.load, $scope.getAutomaticRefreshTime());
            }
        };

        $scope.toggleSelectingObject = function(id) {
            var o = vehicleCollection.get(id);

            if (!o.location().y && !o.location().x) {
                toaster.pop({
                    type: 'info',
                    title: $translate.instant('objects.messages.noGps.title'),
                    body: $translate.instant('objects.messages.noGps.body'),
                    timeout: 10000,
                    bodyOutputType: 'trustedHtml',
                });
                return;
            }

            if (vehicleCollection.isSelected(o)) {
                $scope.toolbarUnselect(true);
            } else {
                $scope.goToObject(o, INFO_WINDOW_OPEN, ZOOM_OBJECT);
            }
        };

        $scope.toolbarUnselect = function(extend) {
            $scope.closeWindow();

            vehicleCollection.unselect();
            $ctrl.gtApi.setSelected(null);

            if (extend) {
                GoogleMapService.extend(
                    vehicleCollection.list().map(function(o) {
                        return {
                            lat: o.location().y,
                            lng: o.location().x,
                        };
                    })
                );
            }
        };

        /**
         * Trigger all critical functions that should be run after loading the
         * objects
         */
        $scope.postDataLoadMapLogic = function(extend) {
            if (!GoogleMapService.ready()) {
                return;
            }

            $scope.generateMarkers();
            $scope.generateNumberWindows();

            if (vehicleCollection.isSelected()) {
                return;
            }

            extend &&
                !GoogleMapService.extend(
                    vehicleCollection.list().map(function(o) {
                        return {
                            lat: o.location().y,
                            lng: o.location().x,
                        };
                    })
                );
        };

        /* =====================================================================
         * Section: Markers
         * =================================================================== */

        /**
         * All vehicle markers visible on map
         */
        $scope.markers = [];

        var statusColorMapping = {
            1: '#2CCB3B',
            2: '#efc93d',
            3: '#CA2742',
            4: '#3bb0d1',
        };

        var statusDirectoryMapping = {
            1: 'active',
            2: 'lost',
            3: 'inactive',
            4: 'engine',
        };

        $scope.generateMarkers = function() {
            var markers = [];
            var list = vehicleCollection.list();

            for (var i in list) {
                var vehicle = list[i];

                if (!$scope.isObjectViewMode() && !vehicleCollection.isSelected(vehicle)) {
                    continue;
                }

                if (!vehicle.location().x && !vehicle.location().y) {
                    continue;
                }

                var url = false;
                var icon = {};

                var rotation = vehicle.location().angle;

                if (!$ctrl.gtApi.getOption('objectsDrawingAuto')) {
                    icon = {
                        fillOpacity: 1,
                        strokeColor: '#333',
                        strokeWeight: 1,
                    };

                    if (vehicle.isObjectMoving()) {
                        icon.path = google.maps.SymbolPath.FORWARD_CLOSED_ARROW;
                        icon.anchor = new google.maps.Point(0, 3);
                        icon.scale = 3.5;
                        icon.rotation = rotation;
                        icon.fillColor = statusColorMapping[vehicle.status];
                    } else {
                        icon.path = google.maps.SymbolPath.CIRCLE;
                        icon.anchor = new google.maps.Point(0, 0);
                        icon.scale = 5.5;
                        icon.rotation = 0;
                        icon.fillColor = statusColorMapping[vehicle.status];
                    }
                } else {
                    var vt = vehicle.get('type') ? vehicle.get('type') : 'car';
                    var directory = statusDirectoryMapping[vehicle.status];

                    url = '/img/icons/vehicles/' + directory + '/' + vt + '.svg?v=' + i;

                    icon = {
                        url: url,
                        anchor: new google.maps.Point(15, 15),
                        scaledSize: new google.maps.Size(30, 30),
                    };
                }

                var marker = {
                    id: i,
                    object: vehicle.id,
                    latitude: vehicle.location().y,
                    longitude: vehicle.location().x,
                    icon: icon,
                    transform: {
                        image: url,
                        rotation: rotation,
                    },
                };
                markers.push(marker);
            }

            $scope.markers = angular.copy(markers);
            setVehicleClusters();

            $scope.applyIconTransformation();
        };

        $scope.goToObject = function(vehicle, window, zoom) {
            vehicleCollection.select(vehicle);

            var mapZoom = GoogleMapService.getZoom();

            if (zoom !== void 0 && zoom) {
                mapZoom = zoom;
                GoogleMapService.setZoom(mapZoom);
            }

            switch (window) {
                case INFO_WINDOW_OPEN: {
                    $scope.setWindowCoords(vehicle.location().y, vehicle.location().x);
                    $scope.openWindow();

                    vehicle.getAddress();
                    getExtendedData();

                    break;
                }
                case INFO_WINDOW_CLOSE: {
                    $scope.closeWindow();
                    break;
                }
                case INFO_WINDOW_NO_ACTION: {
                    $scope.setWindowCoords(vehicle.location().y, vehicle.location().x);
                    break;
                }
                default:
                    break;
            }

            $ctrl.gtApi.setSelected(vehicle);
            $scope.owApi.on.resize();
        };

        $scope.markerClick = function(gm, en, marker) {
            var vehicle = vehicleCollection.get(marker.object);
            var zoom = $rootScope.isSmartDevice ? ZOOM_OBJECT : false;

            $scope.goToObject(vehicle, INFO_WINDOW_OPEN, zoom);
        };

        function setVehicleClusters() {
            vehicleCollection.list().forEach(function(vehicle) {
                vehicle.bounds = GoogleMapService.getBounds(vehicle.location().y, vehicle.location().x);
                vehicle.cluster = null;
            });

            vehicleCollection.list().forEach(function(vehicle) {
                vehicleCollection.cluster(vehicle);
            });
        }

        /**
         * Selected object window options
         */
        $scope.windowOptions = {
            show: false,
            coords: angular.copy($scope.map.center),
            options: {
                boxClass: 'box-object-market-window',
                zIndex: 2,
                disableAutoPan: true,
            },
        };

        $scope.isObjectViewMode = function() {
            return $scope.viewMode === 'object';
        };

        $scope.isRouteViewMode = function() {
            return $scope.viewMode === 'route';
        };

        $scope.changeEventMode = function() {
            if (uiGlRouteApi.ready) {
                uiGlRouteApi.changeEventMode();
            }
        };

        $scope.isMaxSpeedEventMode = function() {
            return uiGlRouteApi.ready ? uiGlRouteApi.isMaxSpeedEventMode() : true;
        };

        /**
         * Change view mode to object / route
         */
        $scope.changeViewMode = function() {
            $scope.closeWindow();
            $scope.viewMode = $scope.viewMode === 'object' ? 'route' : 'object';

            $scope.clearMap();
            $scope.postDataLoadMapLogic(false);

            uiGlRouteApi.destroy();

            if ($scope.viewMode === 'route') {
                $scope.drawObjectRoute();
            } else {
                $scope.mobileRouteStats = false;
                !$rootScope.isSmartDevice && $scope.toolbarUnselect(true);

                $scope.isAutomaticRefresh ? $scope.toggleAutomaticRefresh(true) : $scope.toggleAutomaticRefresh(false);
            }

            return $scope.viewMode;
        };

        $scope.mapOverlays = [];

        $scope.clearMap = function() {
            for (var i = 0; i < $scope.mapOverlays.length; i++) {
                $scope.mapOverlays[i].setMap(null);
            }
            $scope.mapOverlays = [];
        };

        /**
         * Close selected object info window
         */
        $scope.closeWindow = function() {
            $scope.windowOptions.show = false;

            $ctrl.uiObjectWindow.hide();

            updateVehiclesShowAddress();
        };

        var uiGlRouteApi = {
            ready: false,
        };

        $scope.uiGlRouteApi = uiGlRouteApi;

        /**
         * Open selected object info window
         */
        $scope.openWindow = function() {
            $scope.windowOptions.show = true;

            $ctrl.uiObjectWindow.show();

            updateVehiclesShowAddress();
        };

        /**
         * Set selected object info window coordinates
         * @param {float} lat
         * @param {float} lng
         */
        $scope.setWindowCoords = function(lat, lng) {
            $scope.windowOptions.coords = {
                latitude: lat,
                longitude: lng,
            };

            $ctrl.uiObjectWindow.position(lat, lng);
        };

        /**
         * Generated number windows
         */
        $scope.numberWindows = [];

        $scope.groupNearestObjects = function() {
            if (!GoogleMapService.ready()) {
                return [];
            }

            var nearest = vehicleCollection.groupNearestObjects(GoogleMapService.getZoom(), $rootScope.isSmartDevice);
            var results = nearest.groups;

            for (var group in results) {
                for (var i = 0; i < results[group].length; i++) {
                    var o = results[group][i];

                    var projection = GoogleMapService.getOffset(
                        o.location.y,
                        o.location.x,
                        -((nearest.plates.width - 10) * o.column),
                        (nearest.plates.height - 5) * o.offset,
                        GoogleMapService.getZoom()
                    );
                    o.location.y = projection.lat();
                    o.location.x = projection.lng();

                    results[group][i] = o;
                }
            }
            return results;
        };

        var objectTranslatedStatuses = {};

        [1, 2, 3, 4].map(function(o) {
            $translate(['objects.status.' + o]).then(function(v) {
                objectTranslatedStatuses[o] = v['objects.status.' + o];
            });
        });

        /**
         * Generate number windows
         */
        $scope.generateNumberWindows = function() {
            var groups =
                $ctrl.gtApi.getOption('groupObjectsOn') && $scope.isObjectViewMode()
                    ? $scope.groupNearestObjects()
                    : [];

            for (var key in $scope.numberWindows) {
                $scope.numberWindows[key].close();
            }
            $scope.numberWindows = [];

            var collection = vehicleCollection.list();

            for (var key in collection) {
                var vehicle = collection[key];

                if (!$scope.isObjectViewMode() && !vehicleCollection.isSelected(vehicle)) {
                    continue;
                }

                if (!vehicle.location().x && !vehicle.location().y) {
                    continue;
                }

                var location = {
                    y: vehicle.location().y,
                    x: vehicle.location().x,
                };

                var offset = 0;
                var column = 0;
                for (var i in groups) {
                    var list = groups[i];
                    for (var j in list) {
                        var obj = list[j];
                        if (vehicle.id === obj.id) {
                            offset = obj.offset;
                            column = obj.column;
                            location = obj.location;
                            break;
                        }
                    }
                }

                var box = document.createElement('div');

                var name = $ctrl.gtApi.getOption('plateNamesOn') ? vehicle.get('number') : vehicle.get('comment');
                name = name ? name : '- ' + vehicle.get('number') + ' -';

                var oda = $ctrl.gtApi.getOption('objectsDrawingAuto');
                var vt = vehicle.status;

                box.setAttribute('data-id', '' + vehicle.id + '');
                box.innerHTML =
                    '<div class="bubble bubble-' +
                    vehicle.id +
                    (offset > 0 || column > 0 ? ' without-arrow' : '') +
                    '"> ' +
                    '   <div class="bl-name' +
                    (oda ? ' bl-status bl-status-' + vt : '') +
                    '">' +
                    name +
                    '   </div>' +
                    '</div>';

                box.onclick = function() {
                    var id = parseInt(this.getAttribute('data-id'));
                    var vehicle = vehicleCollection.get(id);

                    var zoom = $rootScope.isSmartDevice ? ZOOM_OBJECT : false;

                    $scope.goToObject(vehicle, INFO_WINDOW_OPEN, zoom);
                    $scope.$apply();
                };

                var numberWindow = new InfoBox({
                    boxClass: 'box-object-number-window',
                    zIndex: 1,
                    disableAutoPan: 'false',
                    content: box,
                    visible: true,
                });

                numberWindow.setPosition(new google.maps.LatLng(location.y, location.x));
                numberWindow.open(GoogleMapService.get());

                $scope.numberWindows.push(numberWindow);
            }
        };

        /* =====================================================================
         * Section: Sidebar
         * =================================================================== */

        /**
         * Flag indicating whether the sidebar is open
         */
        $scope.sidebarOpen = false;

        /**
         * Sidebar sort type
         */
        $scope.sortType = null;

        /**
         * Sidebar sort order
         */
        $scope.sortReverse = false;

        /**
         * Set sidebar sort type
         * @param {string} newType
         */
        $scope.setSortType = function(newType) {
            if ($scope.sortType === newType) {
                $scope.sortReverse = !$scope.sortReverse;
            } else {
                $scope.sortType = newType;
                $scope.sortReverse = false;
            }

            $scope.objects.sort(dynamicSort($scope.sortType, $scope.sortReverse));
        };

        $scope.getSortClass = function(type) {
            if (type == $scope.sortType) {
                return $scope.sortReverse ? 'desc' : 'asc';
            }
            return false;
        };

        /**
         * Toggle sidebar state
         */
        $scope.toggleSidebar = function() {
            $scope.sidebarOpen = !$scope.sidebarOpen;

            var $panel = angular.element('.ww-sidebar');
            $panel.removeClass('active');

            if ($scope.sidebarOpen) {
                $panel.addClass('active');

                /*
                 * Update visible columns
                 */
                $ctrl.setColumnVisibility();
            }

            updateVehiclesShowAddress();
            getAddressData();
            getExtendedData();
        };

        $scope.isExtendedDataLoading = false;

        var getAddressData = function() {
            vehicleCollection.list().forEach(function(vehicle) {
                vehicle.getAddress();
            });
        };

        var getExtendedData = function() {
            $scope.isExtendedDataLoading = true;
            vehicleCollection.getExtendedData().then(function() {
                $scope.isExtendedDataLoading = false;
            });
        };

        var updateVehiclesShowAddress = function() {
            vehicleCollection.list().forEach(function(vehicle) {
                if ($scope.sidebarOpen) {
                    if (!$scope.isShowedAddressAsBeam) {
                        vehicle.address.show = true;
                    } else {
                        if (vehicleCollection.isSelected(vehicle) && $scope.windowOptions.show) {
                            vehicle.address.show = true;
                        }
                    }
                    vehicle.extended.show = true;
                } else {
                    vehicle.address.show = false;
                    vehicle.extended.show = false;

                    if (vehicleCollection.isSelected(vehicle)) {
                        vehicle.address.show = vehicle.extended.show = !!$scope.windowOptions.show;
                    }

                    if ($rootScope.isSmartDevice && $scope.mobileMode === 'LIST') {
                        vehicle.address.show = vehicle.extended.show = !!($scope.expandedObject === vehicle);
                    }
                }
            });
        };

        /**
         * Handle the event after clicking the
         */
        $scope.$on('uiSortColumn', function(target, sortOption) {
            $scope.sortType = sortOption.sortColumn;
            $scope.sortReverse = sortOption.sortType === 'desc';

            if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                $scope.$apply();
            }
        });

        /* =====================================================================
         * Section: Route logic
         * =================================================================== */

        $scope.mobileRouteStats = false;

        $scope.isMobileRouteStats = function() {
            return $scope.mobileRouteStats;
        };

        $scope.changeMobileRouteStats = function() {
            $scope.mobileRouteStats = !$scope.mobileRouteStats;
        };

        $scope.isMobileRoute = function() {
            return $scope.mobileMode === 'MAP' && $scope.isRouteViewMode();
        };

        $scope.refreshRoute = function() {
            uiGlRouteApi.refresh().then(function(response) {
                delete response.messageId;

                vehicleCollection.getSelected().update(response);

                $scope.generateMarkers();
                $scope.setWindowCoords(response.last.y, response.last.x);
            });
        };

        $scope.drawObjectRouteInMobile = function(vehicle) {
            $scope.changeMobileModeToMapRoute();

            uiReady().then(function() {
                GoogleMapService.set($scope.map);
                uiGlRouteApi.init(GoogleMapService.get(), $rootScope.app.user.userSettings);

                if (!$ctrl.uiObjectWindow) {
                    var center = $scope.map.center;

                    $ctrl.uiObjectWindow = new UIObjectWindow();
                    $ctrl.uiObjectWindow
                        .compile($scope)
                        .position(center.latitude, center.longitude)
                        .open(GoogleMapService.get());
                }

                $scope.goToObject(vehicle, INFO_WINDOW_NO_ACTION);
                $scope.drawObjectRoute();
            });
        };

        $scope.drawObjectRoute = function() {
            var start = moment
                .utc()
                .startOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
            var end = moment
                .utc()
                .endOf('day')
                .format('YYYY-MM-DD HH:mm:ss');
            var object = {
                id: vehicleCollection.getSelected().id,
                number: vehicleCollection.getSelected().get('number'),
            };

            uiGlRouteApi.setOptions({ object: object, start: start, end: end });
            uiGlRouteApi.draw().then(function() {
                $scope.generateMarkers();
            });

            return true;
        };

        /* =====================================================================
         * Section: Mobile logic
         * =================================================================== */

        /**
         * Mobile filters default state (0 = hidden)
         */
        $scope.showFilters = 0;

        /**
         * Change mobile filters state (hide / show)
         * @param {int} mode
         */
        $scope.changeFiltersMode = function(mode) {
            $scope.showFilters = mode;
        };

        /**
         * Get mobile filers state
         * @returns {int}
         */
        $scope.getShowFilters = function() {
            return $scope.showFilters;
        };

        /**
         * Default mobile view
         */
        $scope.mobileMode = 'LIST';

        /**
         * Change mobile view to map
         */
        $scope.changeMobileModeToMap = function() {
            $scope.mobileMode = 'MAP';
            $scope.gMapPromise();
        };

        /**
         * Change mobile view to map
         */
        $scope.changeMobileModeToMapRoute = function() {
            $scope.mobileMode = 'MAP';
            $scope.viewMode = 'route';
        };

        /**
         * Change mobile view to list
         */
        $scope.changeMobileModeToList = function() {
            if ($scope.isObjectViewMode()) {
                $scope.mobileMode = 'LIST';
                $ctrl.setColumnVisibility();
            }
        };

        /**
         * Show current object location in Google Maps
         * @param {object} object
         */
        $scope.openInGoogleMaps = function(object) {
            var url = 'https://maps.google.com/maps?q=' + object.last.y + '+' + object.last.x;

            if ($rootScope.isSmartDevice) {
                $window.location.href = url;
            } else {
                $window.open(url, 'google');
                return false;
            }
        };

        $scope.showLegendModal = function() {
            $ngConfirm({
                title: $translate.instant('objects.mobile.legend'),
                contentUrl: 'tpl/pages/objects/modals/legend.html',
                animation: 'rotate',
                theme: 'supervan',
                icon: 'pe-7s-info pe-lg pe-va',
                buttons: {
                    no: {
                        text: $translate.instant('general.confirm.close'),
                        btnClass: 'btn-warning',
                    },
                },
            });
        };

        /*
         * Filtered columns section
         */

        var columns = {};
        columns.list = [
            'start',
            'speed',
            'average',
            'averageInput',
            'ignition',
            'fuel',
            'fuelInput',
            'voltage',
            'worktime',
            'distance',
            'business',
            'rpm',
            'temperature',
        ];

        columns.model = columns.list.slice(0);
        columns.applied = [];

        columns.isSelected = function(table, id) {
            var cols = columns[table];
            return cols.indexOf(id) >= 0;
        };

        columns.toggle = function(col) {
            var index = columns.model.indexOf(col);
            if (index !== -1) {
                columns.model.splice(index, 1);
            } else {
                columns.model.push(col);
            }
        };

        $ctrl.updateColumns = function(col) {
            if (col !== void 0) {
                columns.toggle(col);
            }
            columns.applied = columns.model.slice(0);
            columns.updateCookie();
            $ctrl.setColumnVisibility();
        };

        columns.dynamics = [];

        $scope.columnShouldShow = {
            temperature: false,
            fuelInput: false,
        };

        columns.setDynamics = function(list) {
            var columnHasObjectData = function(o, col) {
                switch (col) {
                    case 'fuel':
                        return o.details.fuelLevelCan !== null;
                    case 'fuelInput':
                        return o.details.fuelLevelInput !== null;
                    case 'business':
                        return o.details.business !== null;
                    case 'temperature':
                        if (o.temperatures.sensor !== null) {
                            $scope.columnShouldShow.temperature = true;

                            return true;
                        }
                        return false;
                    default:
                        return false;
                }
            };

            var cols = [];

            for (var i = 0; i < list.length; i++) {
                var o = list[i];
                columnHasObjectData(o, 'fuel') && cols.push('fuel');
                columnHasObjectData(o, 'business') && cols.push('business');
                columnHasObjectData(o, 'temperature') && cols.push('temperature');

                if (columnHasObjectData(o, 'fuelInput')) {
                    $scope.columnShouldShow.fuelInput = true;
                    cols.push('fuelInput');
                    cols.push('averageInput');
                }
            }
            columns.dynamics = cols.filter(function(ix, e) {
                return cols.indexOf(ix) === e;
            });

            $ctrl.setColumnVisibility();
        };

        columns.initCookie = function() {
            var cols = $cookies.get('objectColumns');

            if (typeof cols === 'undefined') {
                columns.updateCookie();
                columns.applied = columns.model;
            }

            if (cols) {
                try {
                    columns.applied = columns.model = JSON.parse(cols);
                } catch (err) {}
            }
            $ctrl.setColumnVisibility();
        };

        columns.updateCookie = function() {
            $cookies.put('objectColumns', JSON.stringify(columns.model), {
                expires: cookieExpirationDate,
            });
        };

        $ctrl.columnsCount = 4 + columns.list.length;
        $ctrl.columnsCountMobile = columns.list.length;

        $ctrl.setColumnVisibility = function() {
            var counter = 4;
            var counterMobile = 0;

            for (var i = 0; i < columns.list.length; i++) {
                var item = columns.list[i];
                var show = false;

                if (columns.applied.indexOf(item) >= 0) {
                    if (item === 'averageInput') {
                        if (columns.dynamics.indexOf('fuelInput') >= 0) {
                            show = true;
                        }
                    } else if (['business', 'fuel', 'fuelInput', 'temperature'].indexOf(item) >= 0) {
                        if (columns.dynamics.indexOf(item) >= 0) {
                            show = true;
                        }
                    } else {
                        show = true;
                    }
                }
                if (show) {
                    $ctrl.visibleColumns[item] = true;
                    counter++;

                    if (item !== 'start') {
                        counterMobile++;
                    }
                } else {
                    $ctrl.visibleColumns[item] = false;
                }
            }

            $ctrl.columnsCount = counter;
            $ctrl.columnsCountMobile = counterMobile;
        };

        $ctrl.isColumnShouldShow = function(col) {
            if (['fuelInput', 'averageInput'].indexOf(col) >= 0) {
                return $scope.columnShouldShow.fuelInput;
            } else if (['temperature'].indexOf(col) >= 0) {
                return $scope.columnShouldShow[col];
            }

            return true;
        };

        $ctrl.getCorrectName = function(item) {
            if (['fuel', 'average'].indexOf(item) >= 0 && $ctrl.isColumnShouldShow(item + 'Input')) {
                return item + 'Can';
            } else {
                return item;
            }
        };

        $ctrl.isColumnVisible = function(col) {
            return $ctrl.visibleColumns[col];
        };

        $ctrl.isColumnTurned = function(col) {
            return columns.isSelected('model', col);
        };

        $ctrl.visibleColumns = {};
        $scope.columns = columns;

        /*
         * Filtered columns section - end
         */

        $scope.openTachographAlertsModal = function(object) {
            var $isolated = $scope.$new(true);
            $isolated.data = object.tachographAlerts;

            $ngConfirm({
                title: $translate.instant('objects.alerts.header'),
                contentUrl: 'js/components/ow-cards/modals/alerts.html',
                animation: 'rotate',
                theme: 'supervan',
                columnClass: 'medium',
                icon: 'pe-7s-speaker pe-lg pe-va',
                scope: $isolated,
                buttons: {
                    no: {
                        text: $translate.instant('general.confirm.save.cancel'),
                        btnClass: 'btn-dark',
                    },
                },
            });
        };

        $scope.editObject = function(vehicle) {
            vehicle.getDrivers().then(function(drivers) {
                var $isolated = $scope.$new(true);

                $isolated.drivers = drivers;
                $isolated.types = [];

                $isolated.id = vehicle.id;
                $isolated.form = {
                    comment: vehicle.get('comment'),
                    type: vehicle.get('type') ? vehicle.get('type') : null,
                };

                $isolated.previous = angular.copy($isolated.form);

                $http.get('/api/applicationSetting/client/vehicleTypes').then(function(response) {
                    $isolated.types = response.data.data;
                });

                $ngConfirm({
                    title: $translate.instant('objects.edit.title') + ' - <b>' + vehicle.get('number') + '</b>',
                    contentUrl: 'tpl/pages/objects/modals/edit.html',
                    animation: 'rotate',
                    theme: 'supervan',
                    columnClass: 'medium',
                    icon: 'pe-7s-pen pe-lg pe-va',
                    scope: $isolated,
                    buttons: {
                        yes: {
                            text: $translate.instant('objects.edit.submit'),
                            btnClass: 'btn-success',
                            action: function(scope) {
                                vehicle.update({ comment: scope.form.comment, type: scope.form.type });

                                if (scope.previous.comment === scope.form.comment) {
                                    delete scope.form.comment;
                                }

                                if (scope.previous.type === scope.form.type) {
                                    delete scope.form.type;
                                }

                                vehicle.edit(scope.id, scope.form);

                                return true;
                            },
                        },
                        no: {
                            text: $translate.instant('objects.edit.cancel'),
                            btnClass: 'btn-dark',
                        },
                    },
                });
            });
        };

        $scope.planning = function(object) {
            $state.go('app.planning', { object: object });
        };

        /*
         * OW Api
         */

        var $owApi = {
            data: {
                modes: ['general', 'drivers', 'can', 'tachograph', 'route'],
            },
            fn: {
                close: function() {
                    if ($scope.isObjectViewMode()) {
                        $scope.toolbarUnselect(false);
                    } else {
                        $scope.closeWindow();
                    }
                },
                route: $scope.changeViewMode,
                isRouteMode: $scope.isRouteViewMode,
            },
            on: {
                resize: function() {
                    if (!GoogleMapService.ready() || !vehicleCollection.isSelected()) {
                        return false;
                    }
                    $timeout(function() {
                        var wo = angular.copy($scope.windowOptions);
                        var point = GoogleMapService.getWindowOffset(
                            wo.coords.latitude,
                            wo.coords.longitude,
                            '.' + wo.options.boxClass
                        );

                        GoogleMapService.panTo(point.lat(), point.lng());
                    }, 100);
                },
            },
            call: {
                change: function() {},
            },
        };

        $scope.owApi = $owApi;

        /*
         * GT Api
         */

        var onGroupObjectsOn = function(value) {
            if ($ctrl.gtApi.access.grouping) {
                if (!value) {
                    $scope.map.type = null;
                    $scope.map.cluster.maxZoom = 1;
                } else {
                    $scope.map.type = 'cluster';
                    $scope.map.cluster.maxZoom = 13;
                }
                $scope.generateNumberWindows();
            }
        };

        var onZonePlaceChanged = function(lat, lng) {
            GoogleMapService.setZoom(ZOOM_OBJECT);
            GoogleMapService.panTo(lat, lng);
            $scope.$apply();
        };

        var gtModes = ['settings'];

        if (
            AccessManagerService.hasExtraFeature('zones-management') &&
            ['ww'].indexOf(DistributionService.code()) >= 0
        ) {
            gtModes.unshift('zones');
        }

        $ctrl.gtApi = {
            modes: gtModes,
            access: {
                grouping: AccessManagerService.hasExtraFeature('always-show-numbers'),
                traffic: false,
            },
            object: null,
            objects: [],
            groups: $rootScope.app.user.groups.others,
            on: {
                load: function() {
                    $scope.load();
                },
                groupObjectsOn: function(v) {
                    onGroupObjectsOn(v);
                },
                plateNamesOn: function(v) {
                    $scope.generateNumberWindows();
                },
                objectsDrawingAuto: function() {
                    $scope.generateMarkers();
                    $scope.generateNumberWindows();
                },
                trafficOnMap: function() {
                    $scope.generateTrafficOnMap();
                },
                objectSelect: function(id) {
                    $scope.toggleSelectingObject(id);
                },
                objectUnselect: function(extend) {
                    $scope.toolbarUnselect(extend);
                },
                zonePlaceChanged: function(lat, lng) {
                    onZonePlaceChanged(lat, lng);
                },
            },
        };

        var uiGTIsReady = function() {
            return $q(function(resolve, reject) {
                $ctrl.gtApi.onInit = function() {
                    $timeout(resolve, 1000);
                };
            });
        };

        /*
         * GT Api End
         */

        var uiReady = function() {
            return $q.all([uiGmapIsReady.promise(), uiGTIsReady()]);
        };

        /**
         * Init the controller
         */
        $scope.init();

        /**
         * Trigger the logic after map load
         */
        $scope.gMapPromise();
    },
]);

/**
 * @TODO - WID-308 - VERIFY - CORRECT THIS !
 */

function dynamicSort(field, reverse) {
    function getObjectProperty(object, keys) {
        return keys.split('.').reduce(function(acc, curr) {
            return (acc || {})[curr];
        }, object);
    }

    return function(a, b) {
        var first = getObjectProperty(a, field);
        var second = getObjectProperty(b, field);

        first = first ? first : '';
        second = second ? second : '';

        var result = first < second ? -1 : first > second ? 1 : 0;

        return result * (reverse ? -1 : 1);
    };
}

app.filter('getUTCDateTime', function() {
    return function(value) {
        if (!value) {
            return null;
        }
        var m = moment.utc(value);
        return m.format('HH:mm');
    };
});

app.filter('customOrderBy', function() {
    return function(items, field, reverse) {
        if (!field) {
            return items;
        }

        return items.sort(dynamicSort(field, reverse));
    };
});

app.filter('num', function() {
    return function(input) {
        return parseInt(input, 10);
    };
});
